import React from 'react';
import T from 'prop-types';
import { Field as FormikField, ErrorMessage as FormikErrorMessage } from 'formik';
import ReactSelect from 'react-select';

export function Field({ additionalCSS = '', error, ...props }) {
  return (
    <FormikField
      className={`focus:outline-gui-focus border border-mid-grey ui-input font-sans ${additionalCSS} ${
        error ? 'border-gui-error' : ''
      }`}
      {...props}
    />
  );
}

Field.propTypes = {
  additionalCSS: T.string,
  error: T.array,
};

export function Label({ children, ...props }) {
  return (
    <label className="flex flex-col ui-text-p3 pb-1 text-dark-grey w-full gap-2" {...props}>
      {children}
    </label>
  );
}

Label.propTypes = {
  children: T.node,
  additionalCSS: T.string,
};

export function ErrorMessage(props) {
  return (
    <FormikErrorMessage {...props}>
      {(errorMessages) => (
        <ul>
          {errorMessages.map((message, messageIndex) => (
            <li className="text-gui-error ui-text-p3" key={messageIndex}>
              {message}
            </li>
          ))}
        </ul>
      )}
    </FormikErrorMessage>
  );
}

export function Select({ ...props }) {
  return (
    <ReactSelect
      {...props}
      unstyled={true}
      classNames={{
        container: () => {
          return 'focus:outline-gui-focus border border-mid-grey ui-input font-sans';
        },
        menu: () => {
          return 'absolute p-2 z-10 border border-mid-grey bg-white rounded shadow-container right-0';
        },
        option: () => {
          return 'group block p-2 hover:bg-light-grey hover:text-cool-black rounded';
        },
      }}
      styles={{
        control: (baseStyles, { hasValue }) => {
          return {
            ...baseStyles,
            color: hasValue ? '' : 'var(--color-neutral-800)',
            minHeight: 'auto',
          };
        },
      }}
    ></ReactSelect>
  );
}

Select.propTypes = ReactSelect.propTypes;
